import React from "react";
import { PlusGrayIcon } from "../../../../CommonUI/Icon/PlusGrayIcon";
import { StateManager } from "../../../../rule-engine-core/Common/StateManager";
import { TestContext } from "../../../../CommonUI/Testing/TestContext";
import {
    RuleTableHeaderActionColumn,
    RuleTableHeaderSplit,
    RuleTableIndexColumn,
} from "../../../DesignUI/CommonStyles";
import { XResultColumn } from "../../CommonUI/XResultColumn";
import { RuleTableEditContext } from "../../../../rule-engine-core/Rule/Table/Rule/RuleTableEditContext";
import { RuleTableConfiguration } from "../../../../rule-engine-core/Rule/Table/Rule/RuleTableConfiguration";
import { RuleTableHeaderColumn } from "./RuleTableHeaderColumn";

interface RuleTableHeaderProps {
    ruleDefinition: RuleTableConfiguration;
    editContext: RuleTableEditContext;
}

export const RuleTableHeader = (props: RuleTableHeaderProps) => {
    const { ruleDefinition, editContext } = props;

    const testContext = React.useContext(TestContext);

    const onAddNewColumnHeader = () => {
        if (testContext) return;

        ruleDefinition.addRuleColumn();

        StateManager.propertyChanged(ruleDefinition, "ruleColumns");
    };

    const onAddNewResultColumnHeader = () => {
        if (testContext) return;
        ruleDefinition.addResultColumn();

        StateManager.propertyChanged(ruleDefinition, "resultColumns");
    };

    return (
        <>
            <RuleTableIndexColumn />
            {ruleDefinition.ruleColumns.map((rule, idx) => {
                return (
                    <RuleTableHeaderColumn
                        key={idx}
                        rule={rule}
                        ruleDefinition={ruleDefinition}
                        editContext={editContext}
                    />
                );
            })}
            <RuleTableHeaderActionColumn
                onClick={onAddNewColumnHeader}
                data-testid="btn-rule-table-add-new-column"
            >
                {!testContext && <PlusGrayIcon />}
            </RuleTableHeaderActionColumn>

            {ruleDefinition.resultColumns.map((rescol) => (
                <XResultColumn
                    resultColumn={rescol}
                    ruleDefinition={ruleDefinition}
                    key={rescol._id}
                />
            ))}

            <RuleTableHeaderActionColumn
                onClick={onAddNewResultColumnHeader}
                data-testid="btn-rule-table-add-new-result-column"
            >
                {ruleDefinition.canChangeOutputs && !testContext ? <PlusGrayIcon /> : null}
            </RuleTableHeaderActionColumn>

            <RuleTableHeaderSplit width={24} />

            <RuleTableIndexColumn height={1} />
            {ruleDefinition.ruleColumns.map((_, idx) => {
                return <RuleTableHeaderSplit key={idx} />;
            })}

            <RuleTableHeaderSplit width={24} />

            {ruleDefinition.resultColumns.map((rescol) => (
                <RuleTableHeaderSplit key={rescol._id} />
            ))}

            <RuleTableHeaderSplit width={24} />
            <RuleTableHeaderSplit width={24} />
        </>
    );
};
